import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { useSettings } from '../../hooks/useSettings';
import { usePartnerAdminNavigation } from '../../hooks/admin/usePartnerAdminNavigation';
import { useAdminData } from '../../hooks/admin/useAdminData';
import { useAdminSettings } from '../../hooks/admin/useAdminSettings';
import { useSubscriptionPlans } from '../../hooks/admin/useSubscriptionPlans';
import { useUserManagement } from '../../hooks/admin/useUserManagement';
import PartnerAdminSidebar from '../admin/PartnerAdminSidebar';
import PartnerAdminTabRenderer from './PartnerAdminTabRenderer';

const PartnerAdminDashboard = () => {
  // Mobile sidebar state
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const { activeTab, handleTabChange, handleLogout } = usePartnerAdminNavigation();
  const adminData = useAdminData(activeTab);
  const adminSettings = useAdminSettings(activeTab);
  const subscriptionPlans = useSubscriptionPlans(activeTab);
  const userManagement = useUserManagement();
  const { 
    settings: appSettings, 
    loading: appSettingsLoading, 
    settingsLoaded: appSettingsLoaded, 
    safeSettings: appSafeSettings 
  } = useSettings();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Header */}
      <div className="mobile-header md:hidden">
        <button
          onClick={() => setSidebarOpen(true)}
          className="bg-white/10 hover:bg-white/20 rounded p-2 transition-colors"
        >
          <Menu size={20} />
        </button>
        <div className="flex items-center gap-2 ml-3">
          {appSettings?.product_logo && (
            <img src={appSettings.product_logo} alt="Logo" className="h-6 object-contain" />
          )}
          <span className="text-lg font-bold">{appSafeSettings?.product_name || 'Partner Admin'}</span>
        </div>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="mobile-overlay md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <PartnerAdminSidebar
        activeTab={activeTab}
        setActiveTab={handleTabChange}
        handleLogout={handleLogout}
        appSettings={appSettings}
        appSettingsLoaded={appSettingsLoaded}
        appSafeSettings={appSafeSettings}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      
      {/* Main Content */}
      <div className="admin-content ml-80 min-h-screen mobile-content">
        <PartnerAdminTabRenderer
          activeTab={activeTab}
          adminData={adminData}
          adminSettings={adminSettings}
          subscriptionPlans={subscriptionPlans}
          userManagement={userManagement}
          appSettings={appSettings}
        />
      </div>
    </div>
  );
};

export default PartnerAdminDashboard;